




import {Component, Prop, Vue} from "vue-property-decorator";
import Ticket from "./Ticket";

@Component
export default class TicketCmpt extends Vue {
    @Prop({type: Object, required: true}) ticket!: Ticket;
}
